const SCROLLED_STATE_CLASS = "scrolled"
const onScroll = () => {
  const scroll = document.documentElement.scrollTop;
  if (scroll > 140) {
    document.body.classList.add(SCROLLED_STATE_CLASS);
  } else if(scroll < 38) {
    
    document.body.classList.remove(SCROLLED_STATE_CLASS)
  }
}
window.addEventListener('scroll', onScroll)


jQuery(document).ready(function(){

  jQuery("#checklocal").click(function(e){
    e.preventDefault();
    jQuery('#zippy_widget_1511').toggle();
  });

});


jQuery(document).ready(function() {
    jQuery('.footer__block.footer__block--menu p.bold').click(function() {
        jQuery(this).toggleClass('active');
    });
});